import { render, staticRenderFns } from "./CandidatesList.vue?vue&type=template&id=11769532&scoped=true"
import script from "./CandidatesList.vue?vue&type=script&lang=js"
export * from "./CandidatesList.vue?vue&type=script&lang=js"
import style0 from "./CandidatesList.vue?vue&type=style&index=0&id=11769532&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11769532",
  null
  
)

export default component.exports